import { render, staticRenderFns } from "./CustomIntegrations.vue?vue&type=template&id=f28182c6"
import script from "./CustomIntegrations.vue?vue&type=script&lang=js"
export * from "./CustomIntegrations.vue?vue&type=script&lang=js"
import style0 from "./CustomIntegrations.vue?vue&type=style&index=0&id=f28182c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports